import { riskControls } from '../data/mockData';

function RiskPage() {
  return (
    <section className="panel-section two-column">
      <div className="table-card accent-card">
        <div className="card-header">
          <div>
            <p className="eyebrow">Section 4</p>
            <h4>Risk Management Controls</h4>
            <p>Emergency handling and high-visibility actions.</p>
          </div>
        </div>
        <div className="risk-grid">
          {riskControls.map((control) => (
            <article key={control.label} className={`risk-card ${control.tone}`}>
              <span>{control.label}</span>
              <strong>{control.value}</strong>
            </article>
          ))}
        </div>
        <div className="danger-zone">
          <div>
            <h5>Emergency Kill Switch</h5>
            <p>
              This placeholder action represents the document requirement to stop all
              trading and cancel open orders.
            </p>
          </div>
          <button type="button" className="danger-button">
            STOP ALL TRADING
          </button>
        </div>
      </div>

      <article className="info-card">
        <p className="eyebrow">Implementation Notes</p>
        <h4>Future API hooks</h4>
        <ul className="activity-list">
          <li>Replace login state with real authentication and route guards.</li>
          <li>Fetch users, brokers, and strategies from separate admin APIs.</li>
          <li>Wire action buttons to secure backend endpoints with confirmations.</li>
          <li>Attach audit logging for every critical admin action.</li>
        </ul>
      </article>
    </section>
  );
}

export default RiskPage;
